import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangWithBorder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1056_1194)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M6.11595 8.87684C6.09029 8.74841 5.20648 4.32934 5.17845 4.18931C5.13466 3.97022 4.94226 3.8125 4.71882 3.8125H3.78132C3.55788 3.8125 3.36548 3.97022 3.3217 4.18931C3.29323 4.33172 2.40851 8.75528 2.3842 8.87681C2.33341 9.13069 2.49807 9.37763 2.75191 9.42838C3.00576 9.47916 3.25273 9.3145 3.30348 9.06066L3.6031 7.5625H4.89704L5.19666 9.06069C5.24745 9.31466 5.49451 9.47919 5.74823 9.42841C6.00207 9.37763 6.16673 9.13069 6.11595 8.87684ZM3.7906 6.625L4.1656 4.75H4.33454L4.70954 6.625H3.7906Z",
					fill: "#FFFFFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.625 7.5625H12.2188V7.09375C12.2188 6.83487 12.0089 6.625 11.75 6.625C11.4911 6.625 11.2812 6.83487 11.2812 7.09375V7.5625H9.875C9.61612 7.5625 9.40625 7.77237 9.40625 8.03125C9.40625 8.29013 9.61612 8.5 9.875 8.5H9.98844C10.2555 9.36287 10.6577 10.0252 11.1002 10.5559C10.74 10.8854 10.3756 11.1555 10.0509 11.4152C9.84878 11.5769 9.816 11.8719 9.97775 12.0741C10.1396 12.2763 10.4346 12.3089 10.6366 12.1473C10.963 11.8861 11.3543 11.5959 11.75 11.2327C12.146 11.5961 12.538 11.8869 12.8634 12.1473C13.0656 12.309 13.3606 12.2762 13.5223 12.0741C13.684 11.8719 13.6512 11.5769 13.4491 11.4152C13.1253 11.1561 12.7604 10.8857 12.3998 10.5559C12.8423 10.0252 13.2445 9.36287 13.5116 8.5H13.625C13.8839 8.5 14.0938 8.29013 14.0938 8.03125C14.0938 7.77237 13.8839 7.5625 13.625 7.5625ZM11.75 9.86703C11.4508 9.49141 11.1816 9.04306 10.9787 8.49687H12.5213C12.3184 9.04306 12.0492 9.49141 11.75 9.86703Z",
					fill: "#FFFFFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.5938 3.34375H7.83122L7.63028 1.73181C7.5425 1.02956 6.94263 0.5 6.23491 0.5H1.40625C0.630844 0.5 0 1.13084 0 1.90625V12.25C0 13.0254 0.630844 13.6562 1.40625 13.6562H5.35884L5.55722 15.2682C5.64484 15.969 6.24472 16.5 6.95262 16.5H14.5938C15.3692 16.5 16 15.8692 16 15.0938V4.75C16 3.97459 15.3692 3.34375 14.5938 3.34375ZM1.40625 12.7188C1.14778 12.7188 0.9375 12.5085 0.9375 12.25V1.90625C0.9375 1.64778 1.14778 1.4375 1.40625 1.4375H6.23491C6.47081 1.4375 6.67078 1.614 6.7 1.84794C6.76794 2.39281 7.98775 12.1783 8.05513 12.7188H1.40625ZM6.46012 14.9297L6.30341 13.6562H7.56103L6.46012 14.9297ZM15.0625 15.0938C15.0625 15.3522 14.8522 15.5625 14.5938 15.5625H7.15231L8.93681 13.4983C9.02816 13.3953 9.06909 13.2585 9.05022 13.1226L7.94809 4.28125H14.5938C14.8522 4.28125 15.0625 4.49153 15.0625 4.75V15.0938Z",
					fill: "#FFFFFF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1056_1194",
			children: /* @__PURE__ */ _jsx("rect", {
				width: "100%",
				height: "100%",
				fill: "currentColor",
				transform: "translate(0 0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLangWithBorder);
export default ForwardRef;
